import { AxiosResponse } from 'axios'
import { axiosInstance } from 'libs'
import { GetStoreDetailRes } from 'types/storeDetail'

export const getStoreDetail = async (
  machine_id: string | number,
  store_id: string | number,
  unit_no: string | number,
  hit_date: string | number,
  calc_num?: string | number,
): Promise<AxiosResponse<GetStoreDetailRes>> => {
  return axiosInstance.get(`/api/similarity-distance/watcher`, {
    params: {
      machine_id,
      store_id,
      unit_no,
      hit_date,
      calc_num,
    },
  })
}
